<template>
  <div>
    <div class="flex-center-vertical is-justify-content-space-between">
      <TitleHeader
        from="report-progress"
        title="Report Progress"
      />

      <div class="is-flex is-flex-direction-column is-align-items-flex-end">
        <div v-if="type === 'v2'" class="flex-center-vertical">
          <div class="flex-center-vertical">
            <InputSlider
              :value="Number(zoomSlider)"
              @change="handleChangeZoom"
              class="mr-5"
            />
            <ButtonSearch
              :value="payloadSurveyId"
              @submit="handleSubmitSearch"
              @clear="handleClearSearch"
              @input="handleInputSearch"
              @focus="handleFocusSearch"
              class="mr-2"
            />
            <div class="btn-filter-progress mr-2">
              <b-dropdown
                ref="dropdownFilterProgress"
                aria-role="list"
                position="is-bottom-left"
                :can-close="false"
                :mobile-modal="false"
                @active-change="handleActiveDropdown"
              >
                <template #trigger>
                  <button
                    class="btn-light filter flex-center-vertical is-justify-content-space-between"
                    :class="{'active': activeDropdown}"
                    @mouseover="handleMouseover({ id: 2 })"
                    @mouseleave="handleMouseover({ reset: true })"
                  >
                    <div class="flex-center">
                      <AdjustableIcon
                        size="14"
                        :color="activeDropdown ? '#3185FC' : dataColor.id === 2 ? dataColor.color : '#000'"
                      />
                      <p class="ml-1 mb-1px">Filter</p>
                    </div>
                    <ArrowDownLight height="7" width="12" />
                  </button>
                </template>
                <div class="container-filter-progress">
                  <p class="averta-black mb-2">Filter</p>
                  <div class="is-flex">
                    <div class="mr-4 pr-4 border-right-2">
                      <div class="flex-center-vertical mb-4">
                        <p class="filter-left">Client</p>
                        <DropdownClients
                          classInput="border-radius-12"
                          :isLittleScroll="true"
                          @clickedDropdown="handleClickDropdown"
                          @selected="updateSelection"
                        />
                      </div>
                      <div class="flex-center-vertical mb-4">
                        <p class="filter-left">Nama Outlet</p>
                        <DropdownStores
                          classInput="border-radius-12"
                          :isLittleScroll="true"
                          @clickedDropdown="handleClickDropdown"
                          @selected="updateSelection"
                        />
                      </div>
                      <div class="flex-center-vertical mb-4">
                        <p class="filter-left">Filter Status</p>
                        <DropdownStatusReport
                          classInput="border-radius-12"
                          width="230px"
                          :isLittleScroll="true"
                          @clickedDropdown="handleClickDropdown"
                          @selected="updateSelection"
                        />
                      </div>
                    </div>
                    <div>
                      <div class="flex-center-vertical mb-4">
                        <p class="filter-right">Filter Tanggal</p>
                        <DropdownFilterDate
                          classInput="border-radius-12"
                          mobileModalClass="date-filter-mobile-modal-report-progress"
                          :saveValue="true"
                          :isLittleScroll="true"
                          @clickedDropdown="handleClickDropdown"
                          @selected="updateSelection"
                        />
                      </div>
                      <div class="flex-center-vertical mb-4">
                        <p class="filter-right">Filter Jatuh Tempo</p>
                        <DropdownFilterDate
                          type="due_dates"
                          classInput="border-radius-12"
                          mobileModalClass="date-filter-mobile-modal-report-progress"
                          variableLS="report_due_dates"
                          variableEmit="due_dates"
                          :saveValue="true"
                          :isLittleScroll="true"
                          @clickedDropdown="handleClickDropdown"
                          @selected="updateSelection"
                        />
                      </div>
                      <!-- <div class="flex-center-vertical is-justify-content-space-between mb-4">
                        <p class="filter-right">Filter Untuk Ringkasan</p>
                        <DropdownPredefine placeholder="Pilih Periode" @selected="updateSelection" />
                      </div> -->
                    </div>
                  </div>
                  <div class="submit-wrapper pt-4 mt-4">
                    <ButtonApp
                      :isSecondary="true"
                      @click="() => handleFilter({ type: 'filter-btn' })"
                    >
                      <div>
                        <p class="averta-bold py-1 px-5">Terapkan</p>
                      </div>
                    </ButtonApp>
                  </div>
                </div>
              </b-dropdown>
            </div>

            <div @mouseover="hoverIcon = true" @mouseleave="hoverIcon = false">
              <ButtonApp
                height="30px"
                :isSecondary="!loadingExport ? true : false"
                :isDisabled="loadingExport"
                class="is-align-self-flex-end px-2"
                @click="handleExport"
              >
                <div class="flex-center px-1" style="transform: translateY(-1px);">
                  <DownloadCloudLightIcon
                    size="21" :color="hoverIcon || loadingExport ? '#FFF' : '#E10009'"
                  />
                  <p class="ml-1 mb-1px">{{ loadingExport ? 'Mengunduh' : 'Export Data' }}</p>
                </div>
              </ButtonApp>
            </div>
          </div>
          <!-- <ButtonFilterProgress :loadAPI="loadAPI" /> -->
        </div>
      </div>
    </div>

    <div>
      <p v-if="filterSummary" class="color-grey">
        <span class="averta-bold mr-1">Filter : </span> {{ filterSummary }}
      </p>
    </div>

    <div v-if="type !== 'v2'" class="flex-center-vertical is-justify-content-space-between c-w-100">
      <div class="is-flex">
        <DropdownClients
          class="mr-3"
          :isLittleScroll="isLittleScroll"
          @selected="updateSelection"
        />
        <DropdownStores :isLittleScroll="isLittleScroll" @selected="updateSelection" />
        <DropdownFilterDate
          :saveValue="true"
          :isLittleScroll="isLittleScroll"
          class="mr-3"
          @selected="updateSelection"
        />
        <DropdownStatusReport :isLittleScroll="isLittleScroll" @selected="updateSelection" />
        <DropdownFilterDate
          title="Filter Jatuh Tempo"
          :saveValue="true"
          :showPredefine="false"
          :isLittleScroll="isLittleScroll"
          class="mr-3"
          @selected="updateSelection"
        />
        <ButtonApp height="38px" class="is-align-self-flex-end mb-1" @click="handleFilter">
          <p class="averta-bold">Terapkan</p>
        </ButtonApp>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
// eslint-disable-next-line no-unused-vars
import { alertErrorMessage } from '@/helpers'

export default {
  name: 'HeaderProgress',
  components: {
    TitleHeader: () => import('./TitleHeader.vue'),
    AdjustableIcon: () => import('@/components/icons/AdjustableIcon'),
    ArrowDownLight: () => import('@/components/icons/ArrowDownLight'),
    DownloadCloudLightIcon: () => import('@/components/icons/DownloadCloudLightIcon'),
    DropdownFilterDate: () => import('@/components/dropdown/DropdownFilterDate.vue'),
    DropdownClients: () => import('@/components/dropdown/DropdownClients.vue'),
    DropdownStores: () => import('@/components/dropdown/DropdownStores.vue'),
    DropdownStatusReport: () => import('@/components/dropdown/DropdownStatusReport.vue'),
    // eslint-disable-next-line vue/no-unused-components
    DropdownPredefine: () => import('@/components/dropdown/DropdownPredefine.vue'),
    ButtonApp: () => import('@/components/button/ButtonApp.vue'),
    ButtonSearch: () => import('@/components/button/ButtonSearch'),
    // ButtonFilterProgress: () => import('@/components/button/ButtonFilterProgress'),
    InputSlider: () => import('./InputSlider.vue')
  },
  props: {
    loadAPI: {
      type: Function
    },
    isLittleScrollProps: {
      type: Boolean
    }
  },
  data () {
    return {
      loadingExport: false,
      isLittleScroll: false,

      payloadSurveyId: '',
      payloadClients: '',
      payloadStores: '',
      payloadDates: null,
      payloadDueDates: null,
      payloadStatus: null,
      payloadSummary: null,
      zoomSlider: 0,

      type: 'v2',
      dataColor: {
        id: null,
        color: '#868686'
      },
      openSearch: false,
      hoverIcon: false,
      activeDropdown: false
    }
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl',
      tempDateScrollTo: 'report/getTempDateScrollTo',
      getSelectedClients: 'report/getSelectedClients',
      getListStores: 'report/getListStores',
      dataStatus: 'report/getDataNavbarReportProgress'
    }),
    filterSummary () {
      const isFiltered = JSON.parse(localStorage.getItem('report_clicked_filter'))
      if (!isFiltered) return false
      const parts = []

      // Check if any filter is applied
      if (
        !this.payloadSurveyId &&
        !this.payloadClients &&
        !this.payloadStores &&
        !this.payloadStatus &&
        !this.payloadDates &&
        !this.payloadDueDates
      ) {
        return ''
      }

      if (this.payloadSurveyId) {
        parts.push(`Survey ID: ${this.payloadSurveyId}`)
      }

      if (this.payloadClients) {
        const clients = this.getSelectedClients
          .filter((item) => item.selected)
          .map((item) => item.vendor_name)
          .join(', ')
        parts.push(`Client: ${clients}`)
      }

      if (this.payloadStores) {
        const stores = this.getListStores
          .filter((item) => item.selected)
          .map((item) => item.store_name)
          .join(', ')
        parts.push(`Toko: ${stores}`)
      }

      if (this.payloadStatus) {
        parts.push(
          `Status: ${this.dataStatus.find((item) => item.afterTitle === this.payloadStatus).title}`
        )
      }

      if (this.payloadDates && this.payloadDates.start && this.payloadDates.end) {
        const start = moment(this.payloadDates.start).format('DD MMMM YYYY')
        const end = moment(this.payloadDates.end).format('DD MMMM YYYY')

        if (start === end) {
          parts.push(`Tanggal: ${end}`)
        } else {
          parts.push(`Tanggal: ${start} – ${end}`)
        }
      } else if (this.payloadDates) {
        parts.push(`Tanggal: Sampai ${moment(this.payloadDates).format('DD MMMM YYYY')}`)
      }

      if (this.payloadDueDates && this.payloadDueDates.start && this.payloadDueDates.end) {
        const start = moment(this.payloadDueDates.start).format('DD MMMM YYYY')
        const end = moment(this.payloadDueDates.end).format('DD MMMM YYYY')

        if (start === end) {
          parts.push(`Jatuh Tempo: ${end}`)
        } else {
          parts.push(`Jatuh Tempo: ${start} – ${end}`)
        }
      }

      return parts.join(' | ')
    }
  },
  methods: {
    handleChangeZoom (value) {
      this.zoomSlider = value
      this.$store.commit('report/setTooltipCardProgress', { zoom: value })
    },
    handleActiveDropdown (val) {
      this.activeDropdown = val
    },
    handleInputSearch (value) {
      this.payloadSurveyId = value
    },
    handleFocusSearch () {
      if (this.$refs.dropdownFilterProgress && this.$refs.dropdownFilterProgress.isActive) {
        this.$refs.dropdownFilterProgress.toggle()
      }
    },
    handleClearSearch () {
      this.payloadSurveyId = ''
      const isFiltered = JSON.parse(localStorage.getItem('report_clicked_filter'))
      if (isFiltered) {
        this.handleFilter()
        localStorage.removeItem('report_clicked_filter')
      }
    },
    handleSubmitSearch (value) {
      this.payloadSurveyId = value
      this.handleFilter()
    },
    handleMouseover (props) {
      const { id = null, reset = false } = props
      if (reset || !this.dataColor.id) {
        this.dataColor = {
          id: reset ? null : id,
          color: reset ? '#868686' : '#3185FC'
        }
      }
    },
    handleClickDropdown (value) {
      setTimeout(() => {
        this.canClose = !value
      }, 200)
    },
    handleFilter (props) {
      const payload = {}
      localStorage.removeItem('report_scroll_table')

      if (this.payloadSurveyId) payload.surveyId = this.payloadSurveyId
      if (this.payloadClients) payload.clients = this.payloadClients
      if (this.payloadStores) payload.stores = this.payloadStores
      if (this.payloadDates) payload.date = this.payloadDates
      if (this.payloadDueDates) payload.dueDates = this.payloadDueDates
      if (this.payloadStatus) payload.status = this.payloadStatus
      if (this.payloadSummary) payload.summary = this.payloadSummary

      this.loadAPI(payload)
      if (props && props.type === 'filter-btn' && this.$refs.dropdownFilterProgress) {
        this.$refs.dropdownFilterProgress.toggle()
      }
    },
    updateSelection (props) {
      switch (props.type) {
        case 'clients':
          this.payloadClients = props.data
          if (props.reset) {
            localStorage.removeItem('report_selected_clients')
            this.handleFilter()
          }
          break
        case 'stores':
          this.payloadStores = props.data
          if (props.reset) {
            localStorage.removeItem('report_selected_stores')
            this.handleFilter()
          }
          break
        case 'dates':
          this.payloadDates = props.data
          if ((this.tempDateScrollTo && this.tempDateScrollTo.startDate) || props.reset) {
            localStorage.removeItem('report_dates')
            this.handleFilter()
          }
          break
        case 'due_dates':
          this.payloadDueDates = props.data
          // localStorage.setItem('report_due_dates', JSON.stringify(props.data))
          if (props.reset) {
            localStorage.removeItem('report_due_dates')
            this.handleFilter()
          }
          break
        case 'summary':
          this.payloadSummary = props.data
          localStorage.setItem('report_summary', JSON.stringify(props.data))
          if (props.reset) {
            localStorage.removeItem('report_summary')
            this.handleFilter()
          }
          break
        case 'status':
          this.payloadStatus = props.data ? props.data.afterTitle : null
          localStorage.setItem('report_status', JSON.stringify(props.data))
          if (props.reset) {
            localStorage.removeItem('report_status')
            this.handleFilter()
          }
          break

        default:
          break
      }
    },
    handlePageRefresh () {
      localStorage.setItem('report_survey_id', this.payloadSurveyId)
    },
    setFilterReportProgress (data, type) {
      this.$store.commit('report/setFilterReportProgress', { data, type })
    },
    handleExport () {
      this.loadingExport = true
      const payload = {
        path: 'export/excel'
      }

      if (this.payloadSurveyId) payload.surveyId = this.payloadSurveyId
      if (this.payloadClients) payload.clients = this.payloadClients
      if (this.payloadStores) payload.stores = this.payloadStores
      if (this.payloadStatus) payload.status = this.payloadStatus

      const date = this.payloadDates
      if (date) {
        if (date.start) {
          payload.startDate = date.start
          payload.endDate = date.end
        } else {
          payload.endDate = date
        }
      } else {
        if (!this.payloadSurveyId.surveyId) {
          payload.startDate = moment(new Date()).format('YYYY-MM-DD')
          payload.endDate = moment(new Date()).format('YYYY-MM-DD')
        }
      }

      if (this.payloadDueDates) {
        payload.startDueDate = this.payloadDueDates.start
        payload.endDueDate = this.payloadDueDates.end
      }

      this.$store
        .dispatch('report/getListReportProgress', payload)
        .then((response) => {
          this.loadingExport = false
          const res = response.data.data
          const url = `${process.env.VUE_APP_SHELL_URL_SOCKET}${res.path}`
          window.location.href = url
        })
        .catch((error) => {
          this.loadingExport = false
          alertErrorMessage(error)
        })
    }
  },
  mounted () {
    this.isLittleScroll = this.isLittleScrollProps
    this.payloadSurveyId = localStorage.getItem('report_survey_id') || ''
    if (localStorage.getItem('report_zoom_slider')) {
      this.zoomSlider = localStorage.getItem('report_zoom_slider')
    }
  },
  created () {
    window.addEventListener('beforeunload', this.handlePageRefresh)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.handlePageRefresh)
  },
  watch: {
    isLittleScrollProps (val) {
      this.isLittleScroll = val
    },
    payloadSurveyId (val) {
      this.setFilterReportProgress(val, 'survey_id')
      if (!val) {
        localStorage.removeItem('report_survey_id')
      }
    },
    payloadClients (val) {
      this.setFilterReportProgress(val, 'client')
      if (!val) {
        localStorage.removeItem('report_selected_clients')
      }
    },
    payloadStores (val) {
      this.setFilterReportProgress(val, 'store')
      if (!val) {
        localStorage.removeItem('report_selected_stores')
      }
    },
    payloadDates (val) {
      this.setFilterReportProgress(val, 'dates')
    },
    payloadDueDates (val) {
      this.setFilterReportProgress(val, 'due_dates')
    },
    payloadStatus (val) {
      this.setFilterReportProgress(val, 'status')
    },
    zoomSlider (val) {
      localStorage.setItem('report_zoom_slider', val)
      this.$emit('updateZoom', val)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.btn-light {
  border-radius: 8px;
  border: 1px solid #CBD5E1;
  padding: 3px 10px;
  background: white;
  transition: background 0.15s ease-in-out, border-color 0.15s ease-in-out, width 0.2s ease-in-out;
  cursor: pointer;
  height: 33px;

  &.active, &:hover {
    background: #e1eeff;
    border-color: #3185fc;

    p {
      color: #3185fc !important;
    }
  }

  &.filter {
    width: 110px;
  }

  &.search.active {
    width: 140px;
  }

  &.search {
    width: 235px;
  }
}

.input-search-progress {
  border: none;
  outline: none;
  width: 90%;
}

.container-filter-progress {
  padding: 20px;
  padding-bottom: 15px;
  border-radius: 20px;
  border: 1px solid #e1e1e1;
  box-shadow: 0px 6px 24px 0px #2525251a;
  background: white;
}

.title-wrapper {
  width: 100px;
}

.filter-left {
  width: 100px;
}

.filter-right {
  width: 145px;
}

.submit-wrapper {
  border-top: 2px dashed #e1e1e1;
  display: flex;
  justify-content: flex-end;
}
</style>

<style>
.btn-filter-progress .dropdown-content {
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
}
</style>
